// extracted by mini-css-extract-plugin
export default {"skipButton":"styles_skipButton__EP5Hp"};